import styled from "styled-components";
import { colors } from "src/theme/colors";
import device from "src/constants/media";
import * as InputStyles from "src/components/ui/input/input.styles";
import { Jumbo } from "src/theme/typography";

export const Wrapper = styled.header`
  padding-top: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${device.tablet} {
    padding-top: 100px;
  }
`;
export const Container = styled.div`
  width: 100%;
  padding: 0 12px;
  @media ${device.mobileM} {
    padding: 0 24px;
  }
  @media ${device.tablet} {
    padding: 0 56px;
  }
  @media ${device.laptop} {
    padding: 0 68px;
  }
  @media ${device.laptopS} {
    width: 872px;
    padding: 0;
    margin: 0 auto;
  }
`;
export const HeroTitle = styled(Jumbo)`
  color: ${colors.white};
  margin-bottom: 24px;
  margin-right: 24px;
  z-index: 5;

  @media ${device.tablet} {
    margin-bottom: 80px;
  }
  @media ${device.laptop} {
    max-width: 50%;
  }
`;
export const SearchWrapper = styled.div`
  position: relative;
  z-index: 2;

  @media ${device.laptop} {
    &::after {
      content: url("/doodle/doodle-flare.svg");
      position: absolute;
      left: -56px;
      bottom: -74px;
    }
  }

  ${InputStyles.InputWrapper} {
    border: none;
  }
`;
export const CatImgWrapper = styled.div`
  display: none;
  @media ${device.laptop} {
    display: block;
    position: absolute;
    right: 150px;
    top: -210px;
  }
`;
export const WomanImgWrapper = styled.div`
  display: none;
  @media ${device.tablet} {
    position: absolute;
    top: -280px;
    right: -240px;
    display: block;
  }
`;
export const DogImgWrapper = styled.div`
  display: none;
  @media ${device.tablet} {
    display: block;
    left: 0;
    position: absolute;
    top: 380px;
    z-index: 1;
  }
  @media ${device.laptop} {
    display: block;
    left: auto;
    position: absolute;
    top: 380px;
  }
`;
export const WomanSmallImgWrapper = styled.div`
  position: absolute;
  top: 96px;
  display: block;
  right: 0;
  z-index: 1;

  @media ${device.tablet} {
    display: none;
  }
`;
export const DogSmallImgWrapper = styled.div`
  position: absolute;
  top: 220px;
  display: block;
  left: 0;
  z-index: 1;
  @media ${device.tablet} {
    display: none;
  }
`;
